/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { llmFeedbackUpdateCompletionFeedback } from "../../funcs/llmFeedbackUpdateCompletionFeedback.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.UpdateCompletionFeedbackRequest$inboundSchema,
};

export const tool$llmFeedbackUpdateCompletionFeedback: ToolDefinition<
  typeof args
> = {
  name: "llm-feedback-update-completion-feedback",
  description: `Update existing completion feedback

Updates or modifies existing feedback for a specific chat completion. Useful for allowing users to revise their initial submissions.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await llmFeedbackUpdateCompletionFeedback(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
